export default "__VITE_ASSET__DxLf0kmJ__"